import React from "react";
import { Table, ConfigProvider } from "antd";
import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";
import dayjs from "dayjs";


const PayrollList = () => {
  const { payrollStore } = useStore();
  const {
    //employeePayrolls,
    // loading,
    // fetchEmployeeIdPayroll,
    // selectedEmployeePayrollData,
    // setIsModalVisible
    employeePayrollBreakdown
  } = payrollStore;

  const formatTime = (time) => {
    if (!time || time === "00:00:00") return "-"; // Handle null, undefined, or midnight (00:00:00)
  
    const parsedTime = dayjs(`1970-01-01 ${time}`, "YYYY-MM-DD HH:mm:ss");
    return parsedTime.isValid() ? parsedTime.format("h:mm A") : "-";
  };

  function formatNoOfHours(timeStr){
    const parts = timeStr.split(":");
  
    // Try to parse first two parts as hours and minutes
    const hours = parseInt(parts[0]) || 0;

  
    return `${hours}h`;
  }
  



  const modalColumns = [
    {
      title: "Date",
      dataIndex: "date",
      align: "center",
      key: "date",
    },
    {
      title: "Time In",
      dataIndex: ["attendanceRecords", "timeIn"],
      align: "center",
      key: "timeIn",
      render: (value) => formatTime(value),
    },
    {
      title: "Time Out",
      dataIndex: ["attendanceRecords", "timeOut"],
      align: "center",
      key: "timeOut",
      render: (value) => formatTime(value),
    },
    {
      title: "No. of Hrs.",
      dataIndex: "noOfHours",
      align: "center",
      key: "noOfHoursours",
      render: (value) => {
        if (!value || value === "00:00:00") return "0"; // Handle null, undefined, or midnight (00:00:00)
        return formatNoOfHours(value);
      }
    },
    {
      title: "OT Hrs",
      dataIndex: "otHoursIfApplicable",
      align: "center",
      key: "otHoursIfApplicable",
      render: (value) => {
        if (!value || value === "00:00:00") return "0"; // Handle null, undefined, or midnight (00:00:00)
        return formatNoOfHours(value);
      }
    },
    {
      title: "Offset",
      dataIndex: "isOffset",
      align: "center",
      key: "isOffset",
      render: (value) => (value ? "Yes" : "No"),
    },
    {
      title: "Leave",
      dataIndex: "isLeave",
      align: "center",
      key: "isLeave",
      render: (value) => (value ? "Yes" : "No"),
    },
  ];



  return (
    <div style={{ width: "100%" }}>
      <ConfigProvider
        theme={{
          token: {
            boxShadowSecondary:
              "0 4px 8px 0 rgba(0, 0, 0.5, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadiusLG: 8,
          },
          components: {
            Table: {
              headerBg: "#6D6D6D",
              headerColor: "white",
              headerSplitColor: "#6D6D6D",
            },
          },
        }}
      >
          <Table
            columns={modalColumns}
            dataSource={employeePayrollBreakdown}
            rowKey="id"
            rowClassName={() => "custom-dark-row"}
          />
      </ConfigProvider>
    </div>
  );
};

export default observer(PayrollList);